import { cn } from '@/lib/utils';

interface DetailRowProps {
  label: string;
  value: React.ReactNode;
  className?: string;
}

/** Label-left / value-right row for narrow side cards. Stack inside a `divide-y` list. */
export function DetailRow({ label, value, className }: DetailRowProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-[7rem_minmax(0,1fr)] items-start gap-2 py-2 text-sm',
        className
      )}
    >
      <dt className="text-muted-foreground">{label}</dt>
      <dd className="break-words">{value}</dd>
    </div>
  );
}
